import { ReactNode } from 'react';
import { useSelector } from 'react-redux';

import { selectConfig } from '@app/redux/config';

import styles from './ModalContainer.module.scss';

type ModalProps = {
  children: ReactNode;
  id: string;
};

export const ModalContainer = ({ children, id }: ModalProps): JSX.Element | null => {
  const { platform } = useSelector(selectConfig);

  let cardStyle = '';
  if (platform === 'Web') {
    cardStyle = `card${id}`;
  } else cardStyle = `cardMobile${id}`;
  return (
    <div data-cy="modal" className={styles['modal']}>
      <div className={styles[`${cardStyle}`]}>{children}</div>
    </div>
  );
};
